import { render, staticRenderFns } from "./page-tab-navigation.vue?vue&type=template&id=90590fd4&scoped=true&"
import script from "./page-tab-navigation.vue?vue&type=script&lang=ts&"
export * from "./page-tab-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./page-tab-navigation.vue?vue&type=style&index=0&id=90590fd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90590fd4",
  null
  
)

export default component.exports